// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function FertilityTrackingTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Fertility Tracking</p>
      <p>
        Log fertilizer, amendment, and biostimulant applications — register products, build custom
        blends, and review application history by room and method.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Applications → Log application — record product, rate, room, zone, and method.</li>
          <li>Applications → History — filter and review past fertility events.</li>
          <li>Product library — register products and save reusable custom blends.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Key features</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Blends combine multiple products for recurring recipes</li>
          <li>Application counts appear on the Arca dashboard summary</li>
          <li>Pair with Applicator Log when coordinating sprays and fertigation</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Register products once, then pick them quickly when logging daily room applications.
      </p>
    </div>
  );
}
